<template>
    <page>
        <module enable-flex>
            <!-- 视图化列表组件（work_type=5501 会员管理） -->
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <!-- 搜索栏 -->
                <template #search>
					<!-- 平台账户集资金汇总 -->
					<div class="stats-bar flex">
						<div class="stats-card card-blue">
							<div class="stats-info">
								<div class="stats-title-row flex-start-center">
									<span class="stats-label">总余额：</span>
									<span class="stats-value">{{formatPrice(summary.balance)}}</span>
								</div>
							</div>
							<div class="stats-icon">￥</div>
						</div>
						<div class="stats-card card-orange">
							<div class="stats-info">
								<div class="stats-title-row flex-start-center">
									<span class="stats-label">保证金总额：</span>
									<span class="stats-value">{{formatPrice(summary.deposit_balance)}}</span>
								</div>
							</div>
							<div class="stats-icon">￥</div>
						</div>
					</div>

                    <m-search ref="search">
                        <m-search-item label="昵称">
                            <c-input name="nickname" maxlength="20" placeholder="请输入昵称"></c-input>
                        </m-search-item>
                        <m-search-item label="手机号码">
                            <c-input name="phone" maxlength="11" placeholder="请输入手机号码"></c-input>
                        </m-search-item>
                        <m-search-item label="状态">
                            <c-checkbox-group name="states" :options="disableEnableDic"></c-checkbox-group>
                        </m-search-item>
                        <m-search-item label="注册时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <!-- 操作按钮区 -->
                <template #operate>
					<c-button v-if="auth('b_member_export')"
							  prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
					</c-button>
                </template>

                <!-- 操作列（固定右侧，通过默认插槽注入静态列） -->
                <c-table-column type="button" label="操作" width="120" fixed="right" button-limit="2">
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_member_edit')" icon="tf-edit" @click="$refs.memberEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_member_vip')" icon="tf-time" @click="$refs.memberVipEdit.open(data)">修改会员有效期</c-table-button>
                    </template>
                </c-table-column>

                <!-- 状态列：启用/禁用开关 -->
                <template #state="{data}">
                    <c-switch v-model="data.state" :state-value="[1, 2]"
                              :state-text="['启用','禁用']"
                              @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                </template>

                <!-- 性别列：文字展示 -->
                <template #gender="{data}">
                    <c-state dict="PUBLIC_GENDER" async :value="data.gender"></c-state>
                </template>

                <template #balance="{data}">
                    <span>￥{{data.balance}}</span>
                </template>

                <template #deposit_balance="{data}">
                    <span>￥{{data.deposit_balance}}</span>
                </template>

                <template #is_vip="{data}">
					<c-state dict="enableDic" :value="data.is_vip"></c-state>
                </template>
            </view-list>

            <!-- 新增/编辑会员弹窗 -->
            <member-edit ref="memberEdit" @resolve="$refs.view.update()"></member-edit>
            <!-- 编辑会员有效期弹窗 -->
            <member-vip-edit ref="memberVipEdit" @resolve="$refs.view.update()"></member-vip-edit>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import memberEdit from "@/pages/mall/member_edit.vue";
import memberVipEdit from "@/pages/mall/member_vip_edit.vue";

export default {
    name: 'm_member',

    components: {
        memberEdit,
        memberVipEdit
    },

    computed: {
        ...mapState(['disableEnableDic', 'saasInfo'])
    },

    data() {
        return {
            /* 视图业务类型（5501=会员管理，对应 TBL_SYS_WORK_TYPE.id） */
            workType: 5501,
			summary: {
				balance: 0,
				deposit_balance: 0
			},
        }
    },

	mounted() {
		this.loadSummary();
	},

    methods: {
		/**
		 * 加载会员账户汇总（顶部汇总卡片，按来源渠道汇总会员收支）
		 */
		loadSummary() {
			this.request({
				url: '/mall/member/finance/summary',
				data: {},
				success: data => {
					this.summary = data;
				}
			});
		},
        /******会员启禁用*********/
        stateHandle(state, next, data) {
            this.request({
                url: '/mall/member/update_state',
                data: {
                    id: data.id,
                    state: state ? 2 : 1
                },
                success: () => {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    next();
                }
            });
        },

        /******删除会员***********/
        removeMember(data) {
            this.$confirm({
                message: '确认删除会员【' + data.member_name + '】？删除后不可恢复',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/mall/member/delete',
                        data: {id: data.id},
                        loading: true,
                        success: () => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.$refs.view.update();
                        }
                    });
                },
                cancel: () => {
                },
            });
        },

		/**
		 * 金额格式化（分转元后展示）
		 */
		formatPrice(price) {
			if (price === null || price === undefined || price === '') return '-';
			return '￥' + parseFloat(price).toFixed(2);
		}
    }
}
</script>

<style lang="stylus" scoped>
	.stats-bar {
		flex-wrap: wrap;
		gap: 10px;
		border-top: 1px solid #F5F5F5;
		padding: 8px 12px;

		.stats-card {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex: 1 1 260px;
			max-width: 360px;
			min-height: 56px;
			padding: 8px 16px;
			border-radius: 6px;
			color: #fff;
			box-sizing: border-box;
			overflow: hidden;

			&.card-blue {
				background: linear-gradient(90deg, #2563eb, #3b82f6);
			}

			&.card-orange {
				background: linear-gradient(90deg, #f97316, #fb923c);
			}

			.stats-info {
				position: relative;
				z-index: 1;

				.stats-title-row {
					display: flex;
					align-items: baseline;
					line-height: 24px;

					.stats-label {
						font-size: 12px;
						opacity: 0.95;
					}

					.stats-value {
						margin-left: 6px;
						font-size: 18px;
						font-weight: bold;
					}
				}
			}

			.stats-icon {
				position: absolute;
				right: 14px;
				top: 50%;
				transform: translateY(-50%);
				font-size: 32px;
				line-height: 1;
				opacity: 0.15;
			}
		}
	}

	.amount-negative {
		color: #f00;
	}

	.expired-text {
		color: #f56c6c;
	}

	.expired-tag {
		margin-left: 4px;
		color: #fff;
		background: #f56c6c;
		padding: 1px 5px;
		border-radius: 3px;
		font-size: 11px;
	}
</style>
